<template>
  <section class="login">
    <auth-layout name="login">
      <template #body>
        <div class="content">
          <form @submit.prevent="goLogin">
            <fieldset>
              <dl>
                <dd class="block">
                  <input
                    v-model="username"
                    :class="{ error: errorIdMessage }"
                    id="username"
                    type="email"
                    :placeholder="$t('id_and_pw')"
                  />
                  <p class="error-message" v-html="errorIdMessage"></p>
                </dd>
              </dl>
              <dl>
                <dd class="block">
                  <input
                    id="password"
                    v-model="password"
                    type="password"
                    :class="{ error: errorPasswordMessage }"
                    :placeholder="$t('pw')"
                  />
                  <p class="error-message" v-html="errorPasswordMessage"></p>
                </dd>
              </dl>
            </fieldset>
            <div class="button-box">
              <Button
                type="submit"
                class="primary"
                :value="$t('personal_user_login')"
              />
            </div>
          </form>
          <!-- <div class="checkbox">
            <label>
              <input type="checkbox" />
              <span v-text="$t('stay_signed_in')"></span>
            </label>
          </div> -->
        </div>
      </template>
    </auth-layout>
  </section>
</template>

<script>
import { Common } from '@src/common';
import eve from '@src/commonEvent';
import { getLogin } from '@api/auth';
import authLayout from '@layouts/authLayout.vue';
import Button from '@components/Button.vue';

export default {
  name: 'login',
  head: {
    title: {
      inner: 'Login',
      separator: '|',
      complement: 'Smart Solution',
    },
    meta: [
      {
        hid: 'description',
        name: 'description',
        content: 'Please Login for Enjoying Smart Solution',
      },
    ],
  },
  components: {
    authLayout,
    Button,
  },
  data() {
    return {
      username: '',
      password: '',
      role_code: '',
      is_auto: 'N',
      errorIdMessage: '',
      errorPasswordMessage: '',
    };
  },
  methods: {
    checkForm() {
      this.errorIdMessage = '';
      this.errorPasswordMessage = '';

      if (!this.username) {
        this.errorIdMessage = eve.Lang.t('common.d_input_id');
        document.getElementById('username').focus();
        return false;
      }

      if (!this.password) {
        this.errorPasswordMessage = eve.Lang.t('common.d_pw_input');
        document.getElementById('password').focus();
        return false;
      }

      return true;
    },

    async goLogin() {
      if (this.checkForm()) {
        const { data } = await getLogin({
          username: this.username,
          password: this.password,
          role_code: this.role_code,
          grant_type: 'password',
        });

        if (data.code === Common.CODE_OK) {
          const userData = data.items;
          sessionStorage.accessToken = `Bearer ${userData.accessToken}`;
          sessionStorage.refreshToken = userData.refreshToken;
          sessionStorage.user_info = JSON.stringify(userData);
          sessionStorage.role_code = userData.user.role_code;
          sessionStorage.setItem('access_type', 'web');

          window.location.replace('/');
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.login {
  p.error-message {
    margin-top: 8px;
    color: $invalid;
  }

  .content {
    padding: 16px 24px;
    border-top: 3px solid $primary;

    fieldset {
      margin-top: 8px;

      dl {
        padding: 6px 0;

        dt {
          width: 100px;
          min-width: 100px;
          font-size: 12px;
          color: $gray-88;
        }

        dd {
          width: 100%;
          font-size: 12px;

          input {
            height: 44px;
          }
        }
      }
    }

    .button-box {
      display: flex;
      width: 100%;
      padding: 15px 0;
    }

    .checkbox span::before {
      border-color: $gray-bf;
    }
  }
}
</style>
